import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context";
import { ViewerFigure } from "../../_shared/figure/viewer-figure";
import { GIPHY_TYPE } from "../types";
import { Giphy } from "./giphy";
const ViewerGiphy = ({
  node,
  nodeIndex,
  NodeViewContainer,
  RicosNodesRenderer
}) => {
  const { config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(
    ViewerFigure,
    {
      node,
      nodeIndex,
      NodeViewContainer,
      RicosNodesRenderer
    },
    /* @__PURE__ */ React.createElement(Giphy, { componentData: node.gifData, config: config[GIPHY_TYPE] })
  );
};
const GiphyRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(ViewerGiphy, { key: node.id, node, ...props });
};
var viewer_giphy_default = GiphyRenderer;
export {
  viewer_giphy_default as default
};
//# sourceMappingURL=viewer-giphy.js.map
